import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {connect} from 'react-redux';

import {EDITION_3D_MODES} from 'App/features/map3DEntities/viewModes/viewModesTypes';
import {RootState} from 'App/store/rootReducer';
import {ControlModes} from 'Libs/map3d/constants';
import {INDICATOR_NAMES} from 'Libs/map3d/indicators_types';

type viewModes3DSlice = {
  isVersionLoaded: boolean;
  currentIndicator: INDICATOR_NAMES | null;
  edition3DMode: EDITION_3D_MODES | null;
  parkingMode: boolean;
  currentTool: ControlModes | null;
};

const initialState: viewModes3DSlice = {
  isVersionLoaded: false,
  currentIndicator: null,
  edition3DMode: null,
  parkingMode: false,
  currentTool: null,
};

const viewModes3DSlice = createSlice({
  name: 'viewModes3D',
  initialState,
  reducers: {
    setIsVersionLoaded: (state, {payload}: PayloadAction<boolean>) => {
      state.isVersionLoaded = payload;
    },
    toggleCurrentIndicator: (
      state,
      {payload}: PayloadAction<INDICATOR_NAMES>,
    ) => {
      state.currentIndicator =
        state.currentIndicator !== payload ? payload : null;
      if (payload && state.edition3DMode) {
        state.edition3DMode = null;
      }
      if (payload && state.parkingMode) {
        state.parkingMode = false;
      }
      if (payload && state.currentTool) {
        state.currentTool = null;
      }
    },
    disableCurrentIndicator: state => {
      state.currentIndicator = null;
    },
    setEdition3DMode: (
      state,
      {payload}: PayloadAction<EDITION_3D_MODES | null>,
    ) => {
      state.edition3DMode = payload;
      if (payload && state.currentIndicator) {
        state.currentIndicator = null;
      }
    },
    disableParkingMode: state => {
      state.parkingMode = false;
    },
    toggleParkingMode: state => {
      state.parkingMode = !state.parkingMode;
      if (state.parkingMode) {
        state.currentIndicator = null;
      }
    },
    disableCurrentTool: state => {
      state.currentTool = null;
    },
    toggleCurrentTool: (state, {payload}: PayloadAction<ControlModes>) => {
      state.currentTool = payload;
      if (payload && state.currentIndicator) {
        state.currentIndicator = null;
      }
    },
  },
});

const map3DViewModesToProps = (state: RootState): viewModes3DSlice =>
  state.map3DEntities.viewModes3D;

export const connectTo3DViewModes = connect(map3DViewModesToProps, null, null, {
  forwardRef: true,
});

export const selectIsVersionLoaded = (state: RootState): boolean =>
  state.map3DEntities.viewModes3D.isVersionLoaded;

export const selectCurrentIndicator = (
  state: RootState,
): INDICATOR_NAMES | null => state.map3DEntities.viewModes3D.currentIndicator;

export const selectEdition3DMode = (
  state: RootState,
): EDITION_3D_MODES | null => state.map3DEntities.viewModes3D.edition3DMode;

export const selectParkingMode = (state: RootState): boolean =>
  state.map3DEntities.viewModes3D.parkingMode;

export const selectCurrentTool = (state: RootState): ControlModes | null =>
  state.map3DEntities.viewModes3D.currentTool;

export const {
  setIsVersionLoaded,
  toggleCurrentIndicator,
  disableCurrentIndicator,
  setEdition3DMode,
  disableParkingMode,
  toggleParkingMode,
  disableCurrentTool,
  toggleCurrentTool,
} = viewModes3DSlice.actions;

export default viewModes3DSlice.reducer;
